// import Internal Components
import IcoMoon from '../../config/platforms/icoMoon';

export default IcoMoon;
